import { render } from "./ViewUser.vue?vue&type=template&id=464fbdd1&scoped=true"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"

import "./ViewUser.vue?vue&type=style&index=0&id=464fbdd1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-464fbdd1"

export default script